export const contactsData = {
    email: 'algorithmic@algorithmicprogrammer.com',
    phone: '7604274267',
    address: 'United States of America',

    sheetAPI: ''
}
